import { IFormOperation, OPERATION_TYPE } from 'src/app/user-identification/models/user-identification';
/**
 * Mock NIF-209 — contrato `config.steps[]` / `fields[]` (sandbox `/models/form`).
 */
export function buildFormModelOperation(): IFormOperation {
	return {
		type: OPERATION_TYPE.FORM,
		uuid: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
		completed: false,
		config: {
			tutorial: true,
			steps: [
				{
					uuid: 'step-uuid-001',
					order: 1,
					title: { es: '¿Cuál es tu nombre completo?' },
					fields: [
						{
							uuid: 'field-uuid-001a',
							id: 'name',
							name: 'name',
							type: 'text',
							title: { es: 'Nombre' },
							col: 12,
							validators: ['required', 'match_ocr'],
						},
						{
							uuid: 'field-uuid-001b',
							id: 'surname',
							name: 'surname',
							type: 'text',
							title: { es: 'Apellidos' },
							col: 12,
							validators: ['required'],
						},
					],
				},
				{
					uuid: 'step-uuid-002',
					order: 2,
					title: { es: 'Introduce tu nº de documento de identidad' },
					fields: [
						{
							uuid: 'field-uuid-002a',
							id: 'id_document_type',
							name: 'id_document_type',
							type: 'select',
							title: { es: 'Tipo de documento' },
							col: 12,
						},
						{
							uuid: 'field-uuid-002b',
							id: 'id_document',
							name: 'id_document',
							type: 'text',
							title: { es: 'Nº documento de identidad' },
							col: 12,
							validators: ['required', 'match_ocr'],
						},
					],
				},
				{
					uuid: 'step-uuid-003',
					order: 3,
					title: { es: 'Selecciona tu fecha de nacimiento' },
					fields: [
						{
							uuid: 'field-uuid-003',
							id: 'birth_date',
							name: 'birth_date',
							type: 'text',
							title: { es: 'Fecha de nacimiento' },
							col: 12,
							validators: ['required', 'match_ocr'],
						},
					],
				},
				{
					uuid: 'step-uuid-004',
					order: 4,
					title: { es: '¿Cuál es tu dirección?' },
					fields: [
						{
							uuid: 'field-uuid-004a',
							id: 'address',
							name: 'address',
							type: 'text',
							title: { es: 'Dirección' },
							col: 12,
							validators: ['required', 'match_ocr'],
						},
						{
							uuid: 'field-uuid-004b',
							id: 'address_number',
							name: 'address_number',
							type: 'text',
							title: { es: 'Nº' },
							col: 4,
							validators: ['required'],
						},
						{
							uuid: 'field-uuid-004c',
							id: 'address_floor',
							name: 'address_floor',
							type: 'text',
							title: { es: 'Piso' },
							col: 4,
						},
						{
							uuid: 'field-uuid-004d',
							id: 'address_door',
							name: 'address_door',
							type: 'text',
							title: { es: 'Puerta' },
							col: 4,
						},
						{
							uuid: 'field-uuid-004e',
							id: 'zip_code',
							name: 'zip_code',
							type: 'text',
							title: { es: 'Código Postal' },
							col: 6,
							validators: ['required'],
						},
						{
							uuid: 'field-uuid-004f',
							id: 'city',
							name: 'city',
							type: 'text',
							title: { es: 'Localidad' },
							col: 6,
							validators: ['required'],
						},
						{
							uuid: 'field-uuid-004g',
							id: 'country',
							name: 'country',
							type: 'select',
							title: { es: 'País' },
							col: 6,
							validators: ['required'],
						},
						{
							uuid: 'field-uuid-004h',
							id: 'province',
							name: 'province',
							type: 'select',
							title: { es: 'Provincia' },
							col: 6,
							validators: ['required'],
						},
					],
				},
				{
					uuid: 'step-uuid-005',
					order: 5,
					title: { es: 'Indícanos tu correo electrónico' },
					fields: [
						{
							uuid: 'field-uuid-005',
							id: 'email',
							name: 'email',
							type: 'text',
							title: { es: 'Email' },
							col: 12,
							validators: ['required', 'email', 'match_ocr'],
						},
					],
				},
				{
					uuid: 'step-uuid-006',
					order: 6,
					title: { es: 'Añade tu número de teléfono' },
					fields: [
						{
							uuid: 'field-uuid-006a',
							id: 'phone_prefix',
							name: 'phone_prefix',
							type: 'select',
							title: { es: 'Prefijo' },
							col: 12,
							options: [
								{ value: '+34', label: { es: '+34' } },
								{ value: '+33', label: { es: '+33' } },
								{ value: '+351', label: { es: '+351' } },
								{ value: '+39', label: { es: '+39' } },
							],
						},
						{
							uuid: 'field-uuid-006b',
							id: 'phone',
							name: 'phone',
							type: 'text',
							title: { es: 'Nº de teléfono' },
							col: 12,
							validators: ['required', 'match_ocr'],
						},
					],
				},
				{
					uuid: 'step-uuid-007',
					order: 7,
					title: { es: 'Introduce el dato solicitado' },
					fields: [
						{
							uuid: 'field-uuid-007',
							id: 'short_text',
							name: 'short_text',
							type: 'text',
							title: { es: 'Texto breve' },
							col: 12,
							validators: ['required'],
						},
					],
				},
				{
					uuid: 'step-uuid-008',
					order: 8,
					title: { es: 'Introduce la información solicitada' },
					fields: [
						{
							uuid: 'field-uuid-008',
							id: 'long_text',
							name: 'long_text',
							type: 'textarea',
							title: { es: 'Texto largo' },
							col: 12,
							validators: ['required'],
						},
					],
				},
				{
					uuid: 'step-uuid-009',
					order: 9,
					title: {
						es: 'Selecciona al menos una de las siguientes opciones',
						en: 'Select at least one of the following options',
						fr: 'Sélectionnez au moins une des options suivantes',
						it: 'Seleziona almeno una delle seguenti opzioni',
						pt: 'Selecione pelo menos uma das seguintes opções',
					},
					fields: [
						{
							uuid: 'field-uuid-009',
							id: 'multi_select',
							name: 'multi_select',
							type: 'checkbox',
							title: { es: 'Selección múltiple' },
							col: 12,
							multiple: true,
							validators: ['required'],
							options: [
								{ value: 'Comunicaciones comerciales', label: { es: 'Comunicaciones comerciales' } },
								{ value: 'Newsletter', label: { es: 'Newsletter' } },
							],
						},
					],
				},
				{
					uuid: 'step-uuid-010',
					order: 10,
					title: {
						es: 'Selecciona una de las siguientes opciones',
						en: 'Select one of the following options',
						fr: 'Sélectionnez une des options suivantes',
						it: 'Seleziona una delle seguenti opzioni',
						pt: 'Selecione uma das seguintes opções',
					},
					fields: [
						{
							uuid: 'field-uuid-010',
							id: 'single_select',
							name: 'single_select',
							type: 'select',
							title: { es: 'Selección única' },
							col: 12,
							validators: ['required'],
							options: [
								{ value: 'Opción A', label: { es: 'Opción A' } },
								{ value: 'Opción B', label: { es: 'Opción B' } },
							],
						},
					],
				},
				{
					uuid: 'step-uuid-011',
					order: 11,
					title: { es: 'Marca las opciones que correspondan' },
					fields: [
						{
							uuid: 'field-uuid-011',
							id: 'checkbox',
							name: 'checkbox',
							type: 'checkbox',
							title: { es: 'Checkbox' },
							col: 12,
							multiple: true,
							validators: ['required'],
							options: [
								{
									value: 'checkbox_option_1',
									label: {
										es: 'He leído y acepto la <a href="https://example.com/info">información adicional</a>',
									},
								},
							],
						},
					],
				},
				{
					uuid: 'step-uuid-012',
					order: 12,
					title: {
						es: '¿Confirmas esta información?',
						en: 'Do you confirm this information?',
						fr: 'Confirmez-vous ces informations ?',
						it: 'Confermi queste informazioni?',
						pt: 'Confirma esta informação?',
					},
					fields: [
						{
							uuid: 'field-uuid-012',
							id: 'yes_no',
							name: 'yes_no',
							type: 'radio',
							title: { es: 'Sí/No' },
							col: 12,
							validators: ['required'],
							options: [
								{ value: 'yes', label: { es: 'Sí' } },
								{ value: 'no', label: { es: 'No' } },
							],
						},
					],
				},
				{
					uuid: 'step-uuid-013',
					order: 13,
					title: { es: 'Acepto los términos indicados' },
					fields: [
						{
							uuid: 'field-uuid-013',
							id: 'legal',
							name: 'legal',
							type: 'checkbox',
							title: { es: 'Aceptación legal' },
							col: 12,
							validators: ['required'],
							options: [
								{
									value: 'legal_clause_1',
									label: {
										es: 'Acepto la <a href="https://example.com/privacy">política de privacidad</a> y los <a href="https://example.com/terms">términos y condiciones</a>',
									},
								},
							],
						},
					],
				},
				{
					uuid: 'step-uuid-014',
					order: 14,
					title: { es: 'Indica la fecha solicitada' },
					fields: [
						{
							uuid: 'field-uuid-014',
							id: 'date',
							name: 'date',
							type: 'text',
							title: { es: 'Fecha' },
							col: 12,
							validators: ['required'],
						},
					],
				},
				{
					uuid: 'step-uuid-015',
					order: 15,
					title: { es: 'Introduce el valor numérico' },
					fields: [
						{
							uuid: 'field-uuid-015',
							id: 'number',
							name: 'number',
							type: 'text',
							title: { es: 'Número' },
							col: 12,
							validators: ['required'],
						},
					],
				},
			],
		},
	};
}
